export function getTouchAnimation() {
    const whatWeDoHolder = document.querySelector(".get-touch-animation-box");
    const canvasForStatic = document.getElementById("get-touch-animation");
    const contextForStatic = canvasForStatic.getContext("2d");
    const filesForStatic = canvasForStatic.dataset.directoryUrl;

    canvasForStatic.width = 960;
    canvasForStatic.height = 540;

    const currentFrameForStatic = index => (`${filesForStatic}/${index + 1}.webp`);
    const frameCountForStatic = 49;
    const imagesForStatic = [];

    const preloadimagesForScrollForStatic = () => {
        for (let i = 1; i <= frameCountForStatic; i++) {
            imagesForStatic[i] = new Image();
            imagesForStatic[i].src = currentFrameForStatic(i);
        }
    };
    preloadimagesForScrollForStatic();

    const imgForStatic = new Image();
    imgForStatic.src = currentFrameForStatic(0);
    imgForStatic.onload = function () {
        contextForStatic.drawImage(imgForStatic, 0, 0);
    };

    let frameIndexStatic = 1;

    function staticImageAnimation() {
        if (frameIndexStatic >= frameCountForStatic - 1) {
            frameIndexStatic = 1;
        }
        frameIndexStatic++;
        requestAnimationFrame(() => {
            contextForStatic.clearRect(0, 0, canvasForStatic.width, canvasForStatic.height);
            contextForStatic.drawImage(imagesForStatic[frameIndexStatic], 0, 0);
        });
    }

    window.addEventListener("scroll", () => {
        const scrollTop = window.scrollY;
        const sectionOffset = whatWeDoHolder.offsetTop;
        if (scrollTop > sectionOffset - window.innerHeight / 3 && !whatWeDoHolder.classList.contains('start-animation')) {
            whatWeDoHolder.classList.add('start-animation');
            setInterval(staticImageAnimation, 30);
        }
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/getTouchAnimation.js